const labels = {
    en: {
        title: "Knowledge Transfer",
        // subtitle_1: 'Diagnosis:',
        parag_1: 'This patient is currently 55 years of age or older and has cardiovascular risk factors. The Diabetes Canada guidelines recommend the use of an angiotensin-converting enzyme (ACE) inhibitor or angiotensin-receptor blocker (ARB) that has demonstrated vascular protection. These include patients with any of the following:',

            parag_1_1: 'Clinical cardiovascular disease (CVD)',

            parag_1_2: 'Age ≥ 55 years with an additional cardiovascular risk factor or end-organ damage (albuminuria, retinopathy, left ventricular hypertrophy)',

            parag_1_3: 'Microvascular complications',

        parag_2: 'The ACE inhibitors and ARBs which have demonstrated cardiovascular protection include:',

            parag_2_1: 'Ramipril 10 mg ',
            parag_2_2: 'Telmisartan 80 mg ',
            parag_2_3: 'Perindopril 8 mg  ',

        reference: [
            '	Diabetes Canada Clinical Practice Guidelines Expert Committee, Stone JA, Houlden RL, Lin P, Udell JA, Verma S. Cardiovascular protection in people with diabetes. Can J Diabetes 2018;42 Suppl 1:S162-S169. doi:10.1016/j.jcjd.2017.10.024'
        ]
    },
    fr: {
        title: "Le transfert du savoir",        
        // subtitle_1: 'Diagnosis:',
        parag_1: 'Ce patient est âgé de 55 ans ou plus et présente des facteurs de risque cardiovasculaire. Les lignes directrices de Diabète Canada recommandent d’utiliser un inhibiteur de l’enzyme de conversion de l’angiotensine (IECA) ou un antagoniste des récepteurs de l’angiotensine (ARA) dont l’effet cardioprotecteur a été démontré pour tous les patients présentant l’une ou l’autre des caractéristiques suivantes :',

            parag_1_1: 'Maladie cardiovasculaire clinique',

            parag_1_2: 'Âge ≥ 55 ans et présence d’un autre facteur de risque cardiovasculaire ou d’une lésion à un organe cible (albuminurie, rétinopathie, hypertrophie ventriculaire gauche)',

            parag_1_3: 'Complications microvasculaires',

        parag_2: 'IECA et ARA dont l’effet cardioprotecteur a été démontré :',

            parag_2_1: 'ramipril à 10 mg ',
            parag_2_2: 'telmisartan à 80 mg  ',
            parag_2_3: 'périndopril à 8 mg  ',
            
        reference: [
            'Comité d’experts des Lignes directrices de pratique clinique de Diabète Canada, Stone JA, Houlden RL, Lin P, Udell JA, Verma S. Protection cardiovasculaire chez les personnes diabétiques. Can J Diabetes (2018) S162-S169. doi : 10.1016/j.jcjd.2017.10.024.'
        ]
    }
};

export default labels